export default __webpack_public_path__ + "static/media/karen_intv_070221_mixdown_0509-0551.f704940d.wav";